import React from 'react';
import { Container } from '@/components/ui/container';
import { Stack, Inline } from '@/components/ui/layout';
import { Heading, Text } from '@/components/ui/typography';
import { Card, CardContent } from '@/components/ui/card';
import { Mail, MapPin } from 'lucide-react';
import { cn } from '@/lib/utils';

function ContactInfo() {
  return (
    <section className="py-12 md:py-16 bg-background">
      <Container>
        <Stack spacing="lg" align="center" className="text-center max-w-4xl mx-auto">
          <Heading level="h2" className="text-3xl md:text-4xl font-bold">
            Contact Us
          </Heading>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full max-w-2xl mt-8">
            <Card className="p-6 bg-card border-border/50 shadow-md hover:shadow-lg transition-shadow">
              <CardContent className="p-0">
                <Inline spacing="md" align="center" className="justify-center md:justify-start">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                    <Mail className="h-6 w-6 text-primary" />
                  </div>
                  <Stack spacing="xs" align="start">
                    <Text className="font-semibold text-sm text-muted-foreground">Email</Text>
                    <Text className="text-base">connect@aievaluator.in</Text>
                  </Stack>
                </Inline>
              </CardContent>
            </Card>
            <Card className="p-6 bg-card border-border/50 shadow-md hover:shadow-lg transition-shadow">
              <CardContent className="p-0">
                <Inline spacing="md" align="center" className="justify-center md:justify-start">
                  <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center">
                    <MapPin className="h-6 w-6 text-primary" />
                  </div>
                  <Stack spacing="xs" align="start">
                    <Text className="font-semibold text-sm text-muted-foreground">Location</Text>
                    <Text className="text-base">Bangalore - 560066 Karnataka, India</Text>
                  </Stack>
                </Inline>
              </CardContent>
            </Card>
          </div>
        </Stack>
      </Container>
    </section>
  );
}

export default ContactInfo;